'use client';

import { useState } from 'react';

import { Container } from '@/components/container';
import { SectionDescription } from '@/components/section-description';

import { Menu } from './_components/menu';
import { TechTag } from './_components/tech-tag';
import { TECHNOLOGIES } from './_components/tech-tag/constants';
import { Category } from './_components/tech-tag/types';

export const TechstackSection = () => {
    const [selectedCategory, setSelectedCategory] = useState<Category>(
        Category.Engineering,
    );

    const handleSelect = (category: Category) => {
        setSelectedCategory(category);
    };

    return (
        <Container
            verticalSpacing
            as="section"
        >
            <SectionDescription
                header="Tools and all that stuff"
                title="Tech stack"
                variant="top"
            />
            <Menu
                selectedCategory={selectedCategory}
                onSelect={handleSelect}
            />
            <div
                className={`
                  mt-10 flex flex-wrap gap-px

                  sm:justify-center
                `}
            >
                {TECHNOLOGIES.map((technology) => (
                    <TechTag
                        key={technology.name}
                        isSelected={technology.category === selectedCategory}
                        {...technology}
                    />
                ))}
            </div>
        </Container>
    );
};
